const searchStrip = {
  hotels: "Mga Hotel", // translated 
  city: "Lungsod", // translated 
  checkIn: "Mag-check in", // translated 
  checkOut: "Mag-check Out", // translated 
  date: "Petsa", // translated 
  persons: "Mga Tao", // translated 
  adults: "Mga Matanda", // translated 
  rooms: "Mga Kwarto", // translated 
  editSearch: "I-edit ang Paghahanap", // translated 
  newSearch: "Bagong Paghahanap", // translated 
  listView: "Tingnan ang Listahan", // translated 
  mapView: "Tingnan ang Mapa", // translated 
};


export default searchStrip;
